import React from 'react';
import Section from './ui/Section';

const AboutContent = ({ title, children }) => (
  <div className="text-white space-y-2 lg:space-y-4">
    {title && <h3 className="text-xl font-bold mb-4">{title}</h3>}
    {children}
  </div>
);

const AboutParagraph = ({ children }) => (
  <p className="text-sm md:text-base leading-normal">
    {children}
  </p>
);

const BlackSection = () => {
  return (
    <Section background="primary" padding="default">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-8">
        {/* Title Column */}
        <div className="lg:col-span-1">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-3 md:mb-6">
            <strong>About</strong> us
          </h2>
        </div>

        {/* First Content Column */}
        <div className="lg:col-span-1">
          <AboutContent>
            <AboutParagraph>
              As a full-service data marketing agency driven by putting people first, we're not interested in the notion of having more data than anyone else — what we're interested in, is having more accurate and meaningful data of value.
            </AboutParagraph>
            <AboutParagraph>
              That's because we know that precise information leads to precise responses to customer needs, and by taking a consultative approach we can help your business grow.
            </AboutParagraph>
          </AboutContent>
        </div>

        {/* Second Content Column */}
        <div className="lg:col-span-1">
          <AboutContent>
            <AboutParagraph>
              Rather than focusing on the short-term tasks at hand, we look at the bigger picture to<br className="hidden sm:block" />
              <span className="sm:hidden"> </span>create long-term value. We build lasting relationships with our customers to deliver better business outcomes.
            </AboutParagraph>
            <AboutParagraph>
              By harnessing the power of data marketing to generate real insight, we can ensure every one of your engagements are targeted and meaningful — helping you to establish yourself as a trusted partner to your customers.
            </AboutParagraph>
          </AboutContent>
        </div>
      </div>
    </Section>
  );
};

export default BlackSection;